import React from 'react';
import SharePieChart from './SharePieChart'
import PropTypes from 'prop-types';
const DualPieChartDisplay = ({ data }) => {
    const chartData = data.filter(element => element.totalCommits > 0);
    return chartData.length > 0 ? (
        <div
            style={{
                border: '2px solid #ccc',
                padding: '30px',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
                marginTop: '20px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}
        >
            <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>
                Developer Contribution Overview
            </h4>
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '40px',
                }}
            >
                <SharePieChart data= {data}/>
            </div>
        </div>
    ):(null)
};

DualPieChartDisplay.propTypes = {
    data: PropTypes.bool,
};
export default DualPieChartDisplay;